<template>
    <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
</template>

<script>
import ProcessosServicos from './ProcessosServicos'

export default {
    data() {
        return {
            contrato: {},
            erros: []
        }
    },

    methods: {
        obterContratoGestor() {
            this.$store.dispatch('addRequest')
            let contratoId = this.$route.query.c
            ProcessosServicos.obterContratoGestor(contratoId).then(response => {
                if (response) {
                    if (response.success) {
                        this.contrato = response.data
                        this.confirmarFinalizarAvisosVencimentoContrato()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarFinalizarAvisosVencimentoContrato() {
            this.$swal({
                title: 'Avisos de Vencimento do Contrato',
                html: `Confirma a finalização dos avisos de vencimento do contrato <b>${this.contrato.vcCodigoEstruturado}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.finalizarAvisosVencimentoContrato(result.value)
                } else {
                    this.$router.push('/')
                }
            })
        },

        finalizarAvisosVencimentoContrato() {
            this.$store.dispatch('addRequest')
            let finalizarDto = {
                idContrato: this.$route.query.c,
                vencimento: this.$route.query.v
            }
            ProcessosServicos.finalizarAvisosVencimentoContrato(
                finalizarDto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.finalizacaoRealizadaComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        finalizacaoRealizadaComSucesso() {
            this.$swal({
                title: 'Avisos de Vencimento do Contrato',
                html: `Finalizados com Sucesso`,
                icon: 'success'
            }).then(result => {
                if (result.value) {
                    this.$router.push('/')
                }
            })
        }
    },

    created() {
        this.obterContratoGestor()
    }
}
</script>
